import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import CardContainer from '../../components/card/card-container.jsx';
import Api from '../../api/global.service.js';
import './cuentas-form.css';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import FormInputMaterialTest from '../../nuup/componentes/Forms/FormInputMaterialTest.jsx';
import FormSelectApiSearchable from '../../nuup/componentes/Forms/FormSelectApiSearchable.jsx';
import Swal from 'sweetalert2';
import { useHistory, useParams } from 'react-router-dom';
import { useCoopConfig, usaCodigoTx, usaMiel } from '../../components/content/coop-config.jsx';
import BlockUi from 'react-block-ui';
import useEtiquetas from '../../hooks/useEtiquetas';
import transformWord, { indefiniteArticle } from '../../utils/transformWord';

const ProductoresForm = () => {
  const history = useHistory();
  const coopConfig = useCoopConfig();
  const redirect = history.location.state?.redirect;
  const [addParcelas, setAddParcelas] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [idMunicipio, setIdMunicipio] = useState(0);
  const [perteneceCooperativa, setPerteneceCooperativa] = useState(1);
  const [idLocalidad, setIdLocalidad] = useState(false);
  const [idCentroAcopio, setIdCentroAcopio] = useState(false);
  const [idRegion, setIdRegion] = useState(false);
  const { uuid } = useParams();
  const { etiquetas } = useEtiquetas();

  // const customStyles = {
  //   control: base => ({
  //     ...base,
  //     flexDirection: 'row-reverse',
  //   }),
  //   clearIndicator: base => ({
  //     ...base,
  //     position: 'absolute',
  //     right: 0,
  //   }),
  //   placeholder: defaultStyles => {
  //     return {
  //       ...defaultStyles,
  //       color: '#666',
  //       fontSize: 14,
  //     };
  //   },
  // };

  useEffect(() => {
    if (uuid == null) return;

    setBlocking(true);
    Api.get('acopios/cuentas', uuid)
      .then(response => {
        const data = response.data;
        ReactDOM.unstable_batchedUpdates(() => {
          reset({
            nombres: data?.nombres,
            apellido_paterno: data?.apellido_paterno,
            apellido_materno: data?.apellido_materno,
            ine: data?.ine,
            curp: data?.curp,
            rfc: data?.rfc,
            no_celular: data?.no_celular,
            clave_tx: data?.clave_tx || '',
            codigo_tx: data?.codigo_tx || '',
            upp: data?.upp || '',
            pertenece_cooperativa: data?.pertenece_cooperativa ?? 1,
          });
          setIdMunicipio(data?.localidad?.id_municipio);
          setValue('id_municipio', data?.localidad?.id_municipio);
          setIdLocalidad(data?.localidad?.id);
          setIdCentroAcopio(data?.id_centro_acopio);
          setValue('id_centro_acopio', data?.id_centro_acopio);
          setPerteneceCooperativa(data?.pertenece_cooperativa ?? 1);
          setBlocking(false);
        });
      })
      .catch(() => setBlocking(false));
  }, []);

  const [formData] = useState({
    nombres: '',
    apellido_paterno: '',
    apellido_materno: '',
    ine: '',
    curp: '',
    rfc: '',
    no_celular: '',
    id_cuenta_region: 0,
    id_municipio: 0,
    id_localidad: 0,
    id_centro_acopio: 0,
    pertenece_cooperativa: 1,
    clave_tx: '',
    codigo_tx: '',
    upp: '',
  });

  const schema = yup.object().shape({
    nombres: yup.string().required('Información obligatoria'),
    apellido_paterno: yup.string().required('Información obligatoria'),
    apellido_materno: yup.string().required('Información obligatoria'),
    ine: yup.string().nullable(),
    curp: yup.string().nullable(),
    rfc: yup.string().nullable(),
    no_celular: yup.string().nullable(),
    clave_tx: yup.string().nullable(),
    codigo_tx: yup.string().nullable(),
    upp: yup.string().nullable(),
    id_cuenta_region:
      uuid == null
        ? yup
            .number()
            .min(1, 'Información obligatoria')
            .transform(value => (isNaN(value) || value === null || value === undefined ? 0 : value))
            .nullable()
        : yup
            .number()
            .transform(value => (isNaN(value) || value === null || value === undefined ? 0 : value))
            .nullable(),
    id_municipio: yup
      .number()
      .min(1, 'Información obligatoria')
      .transform(value => (isNaN(value) || value === null || value === undefined ? 0 : value))
      .nullable(),
    id_localidad: yup
      .number()
      .min(1, 'Información obligatoria')
      .transform(value => (isNaN(value) || value === null || value === undefined ? 0 : value))
      .nullable(),
    id_centro_acopio: yup
      .number()
      .min(1, 'Información obligatoria')
      .transform(value => (isNaN(value) || value === null || value === undefined ? 0 : value))
      .nullable(),
    pertenece_cooperativa: yup
      .number()
      .min(0)
      .required(),
  });

  const {
    reset,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: async (data, context, options) => {
      if (idRegion !== false) data.id_cuenta_region = idRegion;
      if (idMunicipio > 0) data.id_municipio = idMunicipio;
      if (idLocalidad !== false) data.id_localidad = idLocalidad;
      if (idCentroAcopio !== false) data.id_centro_acopio = idCentroAcopio;
      return yupResolver(schema)(data, context, options);
    },
    mode: 'onBlur',
    defaultValues: formData,
  });

  const onSubmit = async values => {
    setBlocking(true);
    try {
      // El backend aún no soporta editar la región de una cuenta existente
      const valuesToUpdate = { ...values };
      delete valuesToUpdate.id_cuenta_region;
      const response = uuid == null ? await Api.create('sic/cuentas', values) : await Api.update('sic/cuentas', uuid, valuesToUpdate);

      const data = response.data.data;
      setTimeout(() => setBlocking(false), 0);
      const res = await Swal.fire({
        icon: 'success',
        title: '',
        text: `Se ${uuid == null ? 'registró' : 'actualizó'} con éxito al productor -> ${uuid == null ? data[0]?.nombres : data?.nombres}`,
        allowOutsideClick: false,
      });

      if (res.isConfirmed) {
        const redirectToEntregasForm =
          redirect === '/admin/acopio/entregas_por_productor/seleccion'
            ? `/admin/acopio/entregas_por_productor/form/${data[0].id}/${data[0].uuid}`
            : null;
        const redirectAfterParcelas = redirectToEntregasForm || redirect || '/admin/cuentas/list';

        if (addParcelas) {
          history.push({
            pathname: `/admin/parcelas/create/${data[0].uuid}`,
            state: {
              redirect: redirectAfterParcelas,
            },
          });
        } else {
          history.push(redirectAfterParcelas);
        }
      }
    } catch (e) {
      setTimeout(() => setBlocking(false), 0);
      Swal.fire({
        icon: 'error',
        title: '',
        text: e,
      });
    }
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
      <CardContainer height={'100%'}>
        <div className="row">
          <div className="col-12">
            <form className="cuentas-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="form-header">
                <p className="titulo-input">{uuid != null ? 'Edición de productor' : 'Registro de nuevo productor'}</p>
                <p className="form-header-sub">Captura los datos del productor. Los campos sin la nota (opcional) son obligatorios.</p>
              </div>

              <div className="form-section">
                <div className="form-section-head">
                  <p className="form-section-title">{'Datos personales'}</p>
                  <p className="form-section-desc">Nombre completo, identificación y datos de contacto del productor.</p>
                </div>
                <div className="form-section-body">
                  <div className="form-grid">
                    <div>
                      <Controller
                        name="nombres"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="nombres"
                            label=""
                            placeholder="Nombres"
                            error={errors.nombres}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="apellido_paterno"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="apellido_paterno"
                            label=""
                            placeholder="Primer apellido"
                            error={errors.apellido_paterno}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="apellido_materno"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="apellido_materno"
                            label=""
                            placeholder="Segundo apellido"
                            error={errors.apellido_materno}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="ine"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="ine"
                            label=""
                            placeholder={`${coopConfig.config?.ine_etiqueta || 'INE'} (opcional)`}
                            error={errors.ine}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="curp"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="curp"
                            label=""
                            placeholder={`${coopConfig.config?.curp_etiqueta || 'CURP'} (opcional)`}
                            error={errors.curp}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="rfc"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="rfc"
                            label=""
                            placeholder={`${coopConfig.config?.rfc_etiqueta || 'RFC'} (opcional)`}
                            error={errors.rfc}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="no_celular"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="no_celular"
                            label=""
                            placeholder="Nº celular (opcional)"
                            error={errors.no_celular}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Controller
                        name="clave_tx"
                        control={control}
                        render={({ field }) => (
                          <FormInputMaterialTest
                            id="clave_tx"
                            label=""
                            placeholder="Clave de Productor (opcional)"
                            error={errors.clave_tx}
                            value={field.value ?? ''}
                            register={() => ({ ...field, value: field.value ?? '' })}
                          />
                        )}
                      />
                    </div>
                    {usaCodigoTx() && (
                      <div>
                        <Controller
                          name="codigo_tx"
                          control={control}
                          render={({ field }) => (
                            <FormInputMaterialTest
                              id="codigo_tx"
                              label=""
                              placeholder="Código de Productor (opcional)"
                              error={errors.codigo_tx}
                              value={field.value ?? ''}
                              register={() => ({ ...field, value: field.value ?? '' })}
                            />
                          )}
                        />
                      </div>
                    )}
                    {usaMiel() && (
                      <div>
                        <Controller
                          name="upp"
                          control={control}
                          render={({ field }) => (
                            <FormInputMaterialTest
                              id="upp"
                              label=""
                              placeholder="UPP (opcional)"
                              error={errors.upp}
                              value={field.value ?? ''}
                              register={() => ({ ...field, value: field.value ?? '' })}
                            />
                          )}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-section">
                <div className="form-section-head">
                  <p className="form-section-title">{'Ubicación'}</p>
                  <p className="form-section-desc">Región, municipio, localidad y centro de acopio asignado al productor.</p>
                </div>
                <div className="form-section-body">
                  <div className="form-grid">
                    {uuid == null && (
                      <div>
                        <FormSelectApiSearchable
                          id="id_cuenta_region"
                          name="id_cuenta_region"
                          label=""
                          url={'sic/regiones'}
                          keyArray="id"
                          labelArray="nombre"
                          placeholder="Región"
                          error={errors.id_cuenta_region}
                          control={control}
                          isClearable
                          pinToTop={opt => /sin asign/i.test(opt.label)}
                          onChange={e => setIdRegion(Number(e.target.value))}
                        />
                      </div>
                    )}
                    <div>
                      <FormSelectApiSearchable
                        id="id_municipio"
                        name="id_municipio"
                        label=""
                        url={'cooperativas_municipios'}
                        keyArray="id"
                        labelArray="nombre"
                        placeholder="Municipio"
                        error={errors.id_municipio}
                        control={control}
                        isClearable
                        onChange={e => {
                          setIdMunicipio(Number(e.target.value));
                          setIdLocalidad(false);
                          setValue('id_localidad', 0);
                        }}
                        onFinish={() => {
                          if (idMunicipio > 0) {
                            setValue('id_municipio', idMunicipio);
                          }
                        }}
                      />
                    </div>
                    <div>
                      <FormSelectApiSearchable
                        id="id_localidad"
                        name="id_localidad"
                        label=""
                        url={'localidades_municipio_all/' + idMunicipio}
                        keyArray="id"
                        labelArray="nombre"
                        placeholder="Localidad"
                        error={errors.id_localidad}
                        control={control}
                        isClearable
                        pinToTop={opt => /sin asign/i.test(opt.label)}
                        onChange={e => setIdLocalidad(Number(e.target.value))}
                        onFinish={() => {
                          if (idLocalidad !== false && idLocalidad > 0) {
                            setValue('id_localidad', idLocalidad);
                          }
                        }}
                      />
                    </div>
                    <div>
                      <FormSelectApiSearchable
                        id="id_centro_acopio"
                        name="id_centro_acopio"
                        label=""
                        url={'sic/centros_de_acopio'}
                        keyArray="id"
                        labelArray="nombre"
                        placeholder="Centro de acopio"
                        error={errors.id_centro_acopio}
                        control={control}
                        isClearable
                        pinToTop={opt => /sin asign/i.test(opt.label)}
                        onChange={e => setIdCentroAcopio(Number(e.target.value))}
                        onFinish={() => {
                          if (idCentroAcopio !== false && idCentroAcopio > 0) {
                            setValue('id_centro_acopio', idCentroAcopio);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-section">
                <div className="form-section-head">
                  <p className="form-section-title">Cooperativa y parcelas</p>
                  <p className="form-section-desc">Relación del productor con la cooperativa y registro de sus parcelas.</p>
                </div>
                <div className="form-section-body">
                  <div className="form-questions">
                    <div>
                      <p className="titulo-pregunta">{'¿El productor pertenece a la cooperativa?'}</p>
                      <div className="form-radio-group">
                        <label className="form-radio-option">
                          <input
                            type="radio"
                            name="pertenece_cooperativa"
                            value={1}
                            checked={perteneceCooperativa == 1}
                            onChange={() => {
                              setValue('pertenece_cooperativa', 1);
                              setPerteneceCooperativa(1);
                            }}
                          />
                          Si
                        </label>
                        <label className="form-radio-option">
                          <input
                            type="radio"
                            name="pertenece_cooperativa"
                            value={0}
                            checked={perteneceCooperativa == 0}
                            onChange={() => {
                              setValue('pertenece_cooperativa', 0);
                              setPerteneceCooperativa(0);
                            }}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    {uuid == null && (
                      <div>
                        <p className="titulo-pregunta">{`¿Quieres agregar ${indefiniteArticle(
                          etiquetas.parcela
                        )} o más ${transformWord(etiquetas.parcela, ['plural', 'lowercase'])} del productor?`}</p>
                        <div className="form-radio-group">
                          <label className="form-radio-option">
                            <input
                              type="radio"
                              name="addParcelas"
                              value="si"
                              checked={addParcelas == true}
                              disabled={false}
                              onChange={() => {
                                setAddParcelas(true);
                              }}
                            />
                            Si
                          </label>
                          <label className="form-radio-option">
                            <input
                              type="radio"
                              name="addParcelas"
                              value="no"
                              checked={addParcelas == false}
                              disabled={false}
                              onChange={() => {
                                setAddParcelas(false);
                              }}
                            />
                            No
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button className="btn btn-sirio" type="submit">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </CardContainer>
    </BlockUi>
  );
};

export default ProductoresForm;
